const AUTH_TOKEN_KEY = "auth_token";
const REFRESH_TOKEN_KEY = "refresh_token";

const userService = {
    login: (authToken: string, refreshToken: string) => {
        localStorage.setItem(AUTH_TOKEN_KEY, authToken);
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    },

    logout: () => {
        localStorage.removeItem(AUTH_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    },

    getAuthToken: (): string | null => {
        return localStorage.getItem(AUTH_TOKEN_KEY);
    },

    getRefreshToken: (): string | null => {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    },
};

export default userService;
